import { render, staticRenderFns } from "./FlingController.vue?vue&type=template&id=1ff7f63c&scoped=true&"
import script from "./FlingController.vue?vue&type=script&lang=js&"
export * from "./FlingController.vue?vue&type=script&lang=js&"
import style0 from "./FlingController.vue?vue&type=style&index=0&id=1ff7f63c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7f63c",
  null
  
)

export default component.exports